
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('circle',{attrs:{"cx":"8","cy":"8","r":"8","fill":"currentColor"}}),_c('path',{attrs:{"fill":"#F7FCFF","d":"M14.6402 9.60987l-1.5-1.5c-.1465-.14648-.3838-.14648-.5303 0l-1.5 1.5c-.2352.23597-.0686.64013.2652.64013h.6434c-.3354 1.2902-1.4997 2.25-2.89339 2.25h-.375V7.625h1.12498c.20711 0 .37501-.16791.37501-.375V6.5c0-.20709-.1679-.375-.37501-.375h-.63403c.60752-.40291 1.00904-1.09139 1.00904-1.875 0-1.24266-1.00736-2.25-2.24999-2.25-1.24264 0-2.24996 1.00734-2.24996 2.25 0 .78361.40151 1.47209 1.00903 1.875h-.63403c-.20709 0-.375.16791-.375.375v.75c0 .20709.16791.375.375.375h1.12498V12.5h-.375c-1.39369 0-2.558-.9598-2.89343-2.25h.64347c.3342 0 .5-.40444.26513-.64013l-1.49998-1.5c-.14648-.14648-.38379-.14648-.53027 0l-1.49998 1.5c-.2352.23597-.06865.64013.26515.64013h.81773C2.80169 12.3748 4.64974 14 6.87513 14h2.24998c2.22539 0 4.07349-1.6252 4.43219-3.75h.8177c.3342 0 .5-.40444.2652-.64013zM8.00011 3.5c.41355 0 .75.33645.75.75s-.33645.75-.75.75c-.41356 0-.74998-.33645-.74998-.75s.33645-.75.74998-.75z"}})])
          )
        }
      }
    